import { render, staticRenderFns } from "./BookingPrestaGuests.vue?vue&type=template&id=06beb696&scoped=true"
import script from "./BookingPrestaGuests.vue?vue&type=script&lang=js"
export * from "./BookingPrestaGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06beb696",
  null
  
)

export default component.exports